module.exports = __webpack_public_path__ + "img/Avatar-3.18194561.svg";